/**
 * Returns all props that start with `data-`.
 * @param props - The icon component's props.
 * @returns All props that start with `data-`.
 */
export const getDataProps = (
  props: Record<string, any>
): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(props).filter(([key]) => key.startsWith('data-'))
  );
};
